import React from 'react';
import PropTypes from 'prop-types';
import { classList } from 'utils/componentsCommon';

const Decoline = ( { color = '', className, ...props }) => {
    const classNames = classList(
        'decoline',
        className,
        color && `color-${color}`);

    return <div className={ classNames } { ...props } />;
};

Decoline.propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

export default Decoline;
